var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVg = function SvgVg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M11.969 12H12v-.031l-.032.032Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 6.262V0h-.002C5.371.002 0 5.374 0 12h6.26V8.475l3.526 3.526h2.182l.032-.032V9.787L8.474 6.262H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M6.07 1.564A12.057 12.057 0 0 0 1.564 6.07v5.929h3.13V4.695H12v-3.13H6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m17.218 12-3.243 3.243a3.651 3.651 0 0 0 6.487 0L17.218 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 10.524 7.736 6.261H6.261L12 12.001v-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M13.565 6.261v5.74c0 2.795 3.653 3.651 3.653 3.651S20.87 14.796 20.87 12V6.261h-7.305Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M18 8.87h-1.565v4.174H18V8.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M17.217 9.652a.783.783 0 1 0 0-1.566.783.783 0 0 0 0 1.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M15.653 7.305h-1.044v1.043h1.044V7.305ZM15.652 9.652h-1.044v1.043h1.044V9.652ZM15.652 12h-1.044v1.044h1.044v-1.043ZM19.826 7.305h-1.044V8.35h1.044V7.305ZM19.826 9.652h-1.044v1.043h1.044V9.652ZM19.826 12h-1.044v1.044h1.044v-1.043Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgVg;